import { createPostRequest, createGetRequest } from "./create-request"
import endpoints from "../config/endpoints"
import {SCHEMA_DEV} from "../config/config"



class Schema {
    static _instance = null
    schema = null
    token = null



    constructor() {
        const isDevEnv = process.env.REACT_APP_STAGE === 'dev' ||   process.env.REACT_APP_STAGE === 'test'

        if (!!isDevEnv) {
            this.schema = SCHEMA_DEV
        } else {
            const begin = window.location.origin.indexOf('://') + 3 // offset adicionado porque o indice retornado eh de onde comeca a string
            let end = window.location.origin.indexOf('.')
            this.schema = window.location.origin.substring(begin, end)
        // this.schema = 'bridgesolutions'
            /*if(this.schema == '://www'){
                let url = window.location.origin.split(/(?<=www.)/igm)[1]
                url = url.substring(0, url.indexOf('.'))
            }*/
        }
    }

    static async get() {
        if (!Schema._instance) {
            Schema._instance = new Schema()

            const params = {
                login: `${Schema._instance.schema}.customercenter`,
                password: '593616de15330c0fb2d55e55410bf994',
                schema: Schema._instance.schema
            }

            const raw = await createPostRequest(endpoints.admin.login, null, params, Schema._instance.schema)
            const res = await raw.json()


            if (raw.status === 401 && res.notEnable) {

                const error = new Error("ERROR CENTRAL")
                throw error
            }


            Schema._instance.username = `${Schema._instance.schema}.customercenter`
            Schema._instance.token = res.data.token
        }

        return Schema._instance
    }

    static async searchInfo() {
        console.log(">>>>>> searchInfo app/src/helpers/schema.js#60")
        if (!Schema._instance) {
            await this.get()
        }

        console.log(">>>>>> before createGetRequest app/src/helpers/schema.js#65")
        const raw = await createGetRequest(endpoints.admin.customerSchema + '/' + Schema._instance.schema, null, {}, Schema._instance.schema)
        console.log({ raw })
        return await raw.json()
    }

}

export default Schema



// WEBPACK FOOTER //
// ./src/helpers/schema.js